export type Context = Record<string, unknown>;

export enum DataDogTeamTags {
  Verifx = 'VERIFX',
  Checkout = 'CHECKOUT'
}

export enum DataDogCustomAttributes {
  CvnaCustomerId = 'cvnaCustomerId'
}

export type FileNameType = string;

export type TrackEventType = {
  name: string;
  context?: Context;
};

export type TrackPageViewType = {
  viewName: string;
  context?: Context;
};

export type TrackErrorType = {
  error?: unknown;
  name: string;
  context?: Context;
};

export type DataDogTrackErrorContextType = {
  name: string;
} & Record<string, unknown>;
